import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Realizacje from "@/pages/Realizacje";
import Pakiety from "@/pages/Pakiety";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQ from "@/pages/FAQ";
import Kontakt from "@/pages/Kontakt";
import ServicePage from "@/pages/ServicePage";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import PolitykaPrywatnosci from "@/pages/PolitykaPrywatnosci";
import Regulamin from "@/pages/Regulamin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="realizacje" element={<Realizacje />} />
            <Route path="pakiety" element={<Pakiety />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="kontakt" element={<Kontakt />} />
            <Route path="strony-www" element={<ServicePage service="web" />} />
            <Route path="wizytowki-google" element={<ServicePage service="google" />} />
            <Route path="grafiki-reklamowe" element={<ServicePage service="graphics" />} />
            <Route path="logo-branding" element={<ServicePage service="logo" />} />
            <Route path="odziez-z-nadrukiem" element={<ServicePage service="apparel" />} />
            <Route path="apisai" element={<ServicePage service="apisai" />} />
            <Route path="polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
            <Route path="regulamin" element={<Regulamin />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
